import React from 'react';
import { DatePicker, Input } from 'antd';

const useFields = () => {
  const fields = [
    {
      name: ['last_name'],
      rules: [{ required: false }],
      input: <Input disabled />
    },
    {
      name: ['first_name'],
      rules: [{ required: false }],
      input: <Input disabled />
    },
    {
      name: ['email'],
      rules: [{ required: true }]
    },
    {
      name: ['phone_number'],
      label: 'phone_number'
    },
    {
      name: ['date_of_birth'],
      input: <DatePicker />
    },
    {
      label: 'address_number',
      name: ['address', 'number']
    },
    {
      label: 'address_street',
      name: ['address', 'street']
    },
    {
      label: 'address_additional',
      name: ['address', 'additional']
    },
    {
      label: 'address_postcode',
      name: ['address', 'postal_code']
    },
    {
      label: 'address_city',
      name: ['address', 'city']
    }
  ];

  return {
    fields
  };
};

export default useFields;
